export default __webpack_public_path__ + "static/media/pen-solid.b054f1e4.svg";